import React, { useEffect, useState } from "react";
import { Row, Col, Form, Input, Select, Dropdown, Space, Carousel } from "antd";
import { DownOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";
import { BiSearch } from "react-icons/bi";
import { FaLocationArrow, FaPlane, FaShoppingBag } from "react-icons/fa";
// import image1 from "../../../assets/frontendassets/NET4SURGE/First Section/firstsection1.jpg";
import image2 from "../../../assets/frontendassets/NET4SURGE/First Section/firstsection2.jpg";
import food from "../../../assets/frontendassets/NET4SURGE/First Section/food.jpg";
import machine from "../../../assets/frontendassets/NET4SURGE/First Section/mechine.png";
import girl from "../../../assets/frontendassets/NET4SURGE/First Section/girl.jpg";
import image3 from "../../../assets/frontendassets/NET4SURGE/First Section/firstsection3.jpg";
import image1 from "../../../assets/frontendassets/websiteimages/SECTION2png.png";
import HomeBanner from "./HomeBanner";
import WebsiteSeo from "../Home/WebsiteSeo"
import CountingBanners from "./CountingBanners";
const { Option } = Select;

const App: React.FC = () => {
  const [borderStyle, setBorderStyle] = useState<string>("none");
  const [currentSlide, setCurrentSlide] = useState(0);
   const [slidesToShow, setSlidesToShow] = useState(3);
  const images = [
    { src: food, alt: "Food" },
    { src: girl, alt: "Girl" },
    { src: machine, alt: "Machine" },
    { src: food, alt: "Food" },
    { src: girl, alt: "Girl" },
    { src: machine, alt: "Machine" },
    { src: food, alt: "Food" },
    { src: girl, alt: "Girl" },
    { src: machine, alt: "Machine" },
  ];

  
    useEffect(() => {
      const handleResize = () => {
        if (window.innerWidth > 1200) {
          setSlidesToShow(3);
        } else if (window.innerWidth > 768) {
          setSlidesToShow(3);
        } else if (window.innerWidth == 768) {
          setSlidesToShow(3);
        } else if (window.innerWidth > 435) {
          setSlidesToShow(1);
        }
        else {
          setSlidesToShow(1);
        }
      };
  
      window.addEventListener('resize', handleResize);
  
      handleResize();
  
      return () => window.removeEventListener('resize', handleResize);
    }, []);
 
  return (
    <>
   
  <HomeBanner />
{/* <CountingBanners /> */}
   
<div
  style={{
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  }}
  className="bg-[#FFF8EC] flex items-center justify-center  py-8 px-4 pt-[50px]"
>
  <div
    className="bg-[#F9B138] w-full max-w-[1100px] md:max-w-[680px]  lg:max-w-[1100px] max-h-[550px] py-0 px-6 lg:rounded-tl-[180px] lg:rounded-br-[180px] xs:rounded-tl-[30px] xs:rounded-br-[30px] xxs:rounded-tl-[30px] xxs:rounded-br-[30px] md:rounded-tl-[150px] md:rounded-br-[150px] xl:pl-[8rem] xl:pr-[8rem]"
  >
    <Row className="pt-12 pb-12" align={"middle"}>
      <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} className="p-2 md:p-0 text-center">
      <p
  className="text-xl sm:text-2xl md:text-2xl lg:text-3xl xl:text-3xl text-black font-medium mb-3 w-full flex justify-center text-center"
  style={{ fontFamily: '"Manrope", sans-serif' }}
>
  Let’s find anything around you
</p>


<p
  className="text-sm sm:text-md md:text-lg lg:text-lg xl:text-xl text-black font-normal mb-3 w-full flex justify-center text-center"
  style={{ fontFamily: '"Manrope", sans-serif' }}
>
  Our commitment is to provide solutions that transcend <br className="hidden md:block" /> geographical boundaries.
</p>
<Carousel
     autoplay
     autoplaySpeed={3000}
      dots={false}
      beforeChange={(prev, next) => setCurrentSlide(next)}
      className="w-full  mx-auto"
      slidesToShow={slidesToShow}
      draggable
      infinite
    >
      {images.map((image, index) => (
        <div key={index} className="flex justify-center">
          <img
            src={image.src}
            alt={image.alt}
            className={`rounded-lg  cursor-pointer  
              ${
                index === currentSlide + 1 
                  ? "rounded-lg w-40  h-44 md:w-60 md:h-[180px] lg:w-[21rem] lg:h-80  " // Center Image
                  : "rounded-lg w-36 xs:mt-4 xxs:mt-4 md:mt-2 xs:w-[33rem] xxs:w-[31rem]  h-40  md:h-[158px] lg:w-[20rem] lg:h-72  " // Side Images
              }`}
          />
        </div>
      ))}
    </Carousel>

      </Col>
    </Row>
  </div>
</div>

    </>
  );
};

export default App;
